import {createSlice, createAsyncThunk, current} from "@reduxjs/toolkit";
import { api } from "../../api/httpclient";


const defaultFormInitialValues = {
   newPassword: "",
   newPasswordConfirmed: ""
};

const initialState = {
    pageLoaded: false, pageDisposed: true,
    processing: false, processingText: "",
    mode: 0, 
    formKey: (new Date()).toString(), formInitialValues: {...defaultFormInitialValues}, formValues: {...defaultFormInitialValues}, formServerErrors: [], 

};

const resetPasswordPageSlice = createSlice({
    name: "resetPasswordPage",
    initialState: initialState,
    reducers:{
        setInitialState: (state, action) =>  ({...initialState}),//no payload

        setProcessing: (state, action) => {
            //payload: {processing=true, processingText=false}, when processing is false, processingText is "" 
            const {processing=true, processingText=""} = action.payload;

            return ({...state, processing: processing, processingText: processing==false ? "" : processingText});
        },

        setPageValue: (state, action) => ({...state, [action.payload.id]: action.payload.value}),//payload: {id: , value:}

        setFormValue: (state, action) => {
            //payload: {id: fieldId, value: fieldValue}
            let id = action.payload.id;
            let value = action.payload.value;

            return ({
                ...state, 
                formValues: {...state.formValues, [id]: value}
            });
        },   

        setFormServerErrors: (state, action) => ({...state, formServerErrors: [...action.payload]}),

        disposePage: (state, action) => {
            //payload: bool  
            if (action.payload)
                return {...initialState};
            else  
                return {...state, pageDisposed: false};
        },
    }
});

export default resetPasswordPageSlice.reducer;


export const isUserResetPasswordValid = (code, t) => async (dispatch, getState) => {
    let url = "auth/isuserresetpasswordvalid";
    let title = t("slices.loadingPage");

    //start with initial values
    dispatch(setInitialState());

    //undispose page
    dispatch(disposePage(false));

    //show loader
    dispatch(setProcessing({processing: true, processingText: title}));
    
    try{
        var response = await api({            
            url:url,
            method:  'post',
            data: {
                code: code
             },
            //headers:{'h':'1'}
        });

        //i am here +. i can safely access response.data.Succeeded which is always true and response.data.Data
        if(getState().resetPasswordPage.pageDisposed)
           return;

        let data = response.data.Data;   

        return Promise.resolve(response);
    }
    catch(err)
    {
        //i am here => could be any error included 200 and Succeeded=false
        return Promise.reject(err);
    }
};


export const saveEntity = (newPassword, newPasswordConfirmed, code, t) => async (dispatch, getState) => {
    const pageState = getState().alertsPage;

    let url = "auth/applyuserresetpassword";
    let title = t("slices.resettingPass");

    //show loader
    dispatch(setProcessing({processing: true, processingText: title}));
    
    try{
        var response = await api({            
            url:url,
            method:  'post',
            data: {
                code: code,
                password: newPassword,
                passwordConfirmed: newPasswordConfirmed
             },
            //headers:{'h':'1'}
        });

        //i am here +. i can safely access response.data.Succeeded which is always true and response.data.Data
        if(getState().resetPasswordPage.pageDisposed)
           return;

        let data = response.data.Data;        

        return Promise.resolve(response);
    }
    catch(err)
    {
        //i am here => could be any error included 200 and Succeeded=false
        return Promise.reject(err);
    }
};


export const { setInitialState, setProcessing, setPageValue, setFormValue, setFormServerErrors, disposePage } = resetPasswordPageSlice.actions;

